import React from 'react';
import { Link } from 'react-router-dom';

const Preferences = () => {
  return (
    <div className="flex bg-gray-100">
      {/* Sidebar */}
      <div className="w-1/5 bg-gray-100 border-r text-black hover:text-gray-800 p-4">
        <h1 className="text-xl font-bold mb-4">Settings</h1>
        <div>
          {/* Sidebar Links */}
          <Link
            to="/dashboard/system-config/wide-settings"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            General
          </Link>
          <Link
            to="/dashboard/system-config/preferences"
            className="w-full block text-left py-2 px-4 mb-2 rounded bg-black text-white "
          >
            Preferences
          </Link>

          <Link
            to="/dashboard/system-config/notifications"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Notifications
          </Link>

          <Link
            to="/dashboard/system-config/language"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Language Settings
          </Link>

          <Link
            to="/dashboard/system-config/currency"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Currency Settings
          </Link>

          <Link
            to="/dashboard/system-config/hotel-config"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Hotel Configuration
          </Link>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-5/6 bg-gray-50 p-8 flex flex-col justify-start">
        {/* Header */}
        <div className="mb-6">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl text-black font-bold">Settings &gt; Preferences</h2>
              <p className="text-gray-500 font-semibold">Customize until match to your workflows</p>
            </div>
            <div className="flex space-x-4">
              <button className="px-6 py-2 bg-cyan-500 text-white text-sm font-semibold rounded shadow-md hover:text-black transition-all">
                Save
              </button>
              <button className="px-6 py-2 bg-red-500 text-white text-sm font-semibold rounded shadow-md hover:text-black transition-all">
                Cancel
              </button>
            </div>
          </div>
        </div>

        {/* Main Content Section */}
        <div className="bg-white p-6 flex-grow">
          {/* Conditional Content Based on Active Section */}

          <>
            <div className="mb-6">
              <h1 className="text-xl font-bold text-black">Preferences</h1>
              <p className="text-gray-500 font-semibold">Customize until match to your workflows</p>
              <hr className="border-t border-gray-300 mt-1" />
            </div>

            {/* Theme Selection */}
            <div className="mb-6">
              <h2 className="text-lg font-semibold">Select theme</h2>
              <div className="flex space-x-6 mt-4 justify-center ">
                <div className="border border-black rounded-lg p-4 w-1/3">
                  <div className="bg-gray-200 h-20 w-full rounded mb-8"></div>
                  <div className="bg-gray-300 h-6 w-full rounded mb-2"></div>
                  <div className="bg-gray-300 h-6 w-full rounded"></div>
                  <p className="mt-4 font-semibold">Light Mode</p>
                </div>
                <div className="border rounded-lg p-4 w-1/3 text-center">
                  <div className="bg-black h-20 w-full rounded mb-8"></div>
                  <div className="bg-gray-700 h-6 w-full rounded mb-2"></div>
                  <div className="bg-gray-700 h-6 w-full rounded"></div>
                  <p className="mt-4 font-semibold text-black">Dark Mode</p>
                </div>
              </div>
            </div>

            {/* Customize Primary Color */}
            <div className="mb-6">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-lg text-black font-semibold">Customize primary color</h2>
                  <p className="text-gray-500 font-semibold">
                    Customize until match to your workflows
                  </p>
                </div>
                <div className="flex items-center">
                  <input type="color" value="#000000ff" className="w-16 h-8 border rounded" />
                  <span className="ml-4 font-mono text-gray-700">#000000ff</span>
                </div>
              </div>
            </div>

            {/* Transparent Sidebar */}
            <div>
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-lg text-black font-semibold">Transparent Sidebar</h2>
                  <p className="text-gray-500 font-semibold">
                    Add a Transparency layer to your sidebar
                  </p>
                </div>
                <div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" />
                    <div className="w-11 h-6 bg-gray-300 peer-focus:ring-2 rounded-full peer peer-checked:bg-blue-500">
                      <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform peer-checked:translate-x-5"></div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default Preferences;
